import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

// Enlaces públicos para que los conductores informen qué territorios se
// trabajaron en sus salidas (página InformeConductor, sólo vista para mayores).
export const useInformeTokens = () => {
  const api = useApi()

  const getPublicUrl = (token) => `${window.location.origin}/informe-conductor?token=${token}`

  const getTokens = () => api.get('/api/informes/tokens')

  const createToken = (payload) => api.post('/api/informes/tokens', payload)

  const updateToken = (token, payload) => api.put(`/api/informes/tokens/${token}`, payload)

  const revokeToken = (token) => api.del(`/api/informes/tokens/${token}`)

  const getInformes = () => api.get('/api/informes/salidas')

  const reabrirInforme = (salidaId) => api.del(`/api/informes/salidas/${salidaId}`)

  const fetchPublicInforme = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/informe/${token}`)
    return res.json()
  }

  const postInforme = async (token, salidaId, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/informe/${token}/salidas/${salidaId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  // Imagen de una manzana (mismo sidecar mapa-mayores-service/ que la salida
  // para mayores); puede no estar disponible, el <img> maneja `error`.
  const getMapaUrl = (token, terrKey, mzIdx) =>
    `${BASE_URL}/api/public/informe/${token}/mapa/${encodeURIComponent(terrKey)}/${mzIdx}.png`

  return {
    getPublicUrl,
    getMapaUrl,
    getTokens,
    createToken,
    updateToken,
    revokeToken,
    getInformes,
    reabrirInforme,
    fetchPublicInforme,
    postInforme,
  }
}
